import { fetchDataAPI } from '../helpers/fetchDataAPI';
import { URL_BASE_API } from './glogal';
import { store } from '../store'


export const getVersion = async () => {
    const url = `${URL_BASE_API}/api/version/getversion`;

    const rsp = fetchDataAPI(
        url,
        null
    );
    
    return rsp;
}
